import OrderHistoryPanel from "./orderHistoryPanel.container";

export default OrderHistoryPanel;
